import React from 'react';

// Shared SVG wrapper for consistent sizing
const Svg = ({ size = 16, className = '', style = {}, children, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ flexShrink: 0, ...style }}
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
);

// ── Navigation & UI ──

export const ChevronUp = (props) => (
  <Svg {...props}>
    <path d="M4 10l4-4 4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ChevronDown = (props) => (
  <Svg {...props}>
    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ChevronRight = (props) => (
  <Svg {...props}>
    <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ArrowRight = (props) => (
  <Svg {...props}>
    <path d="M3 8h10m-4-4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ArrowLeft = (props) => (
  <Svg {...props}>
    <path d="M13 8H3m4-4L3 8l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ArrowDown = (props) => (
  <Svg {...props}>
    <path d="M8 3v10m-4-4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ArrowUp = (props) => (
  <Svg {...props}>
    <path d="M8 13V3m-4 4l4-4 4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Close = (props) => (
  <Svg {...props}>
    <path d="M4 4l8 8m0-8l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Check = (props) => (
  <Svg {...props}>
    <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

// ── Header & Actions ──

export const Sun = (props) => (
  <Svg {...props}>
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8 1.5v1.5m0 10v1.5m-4.6-11.1l1 1m7.2 7.2l1 1M1.5 8H3m10 0h1.5m-11.1 4.6l1-1m7.2-7.2l1-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Moon = (props) => (
  <Svg {...props}>
    <path d="M13.5 8.5a5.5 5.5 0 01-7.5-5c0-.7.1-1.4.3-2A6 6 0 1013.5 8.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

/** Warm mode icon — sun with softer, fewer rays suggesting gentle warmth. */
export const SunWarm = (props) => (
  <Svg {...props}>
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8 2v1.5M8 12.5V14M2 8h1.5M12.5 8H14M3.9 3.9l1 1M11.1 11.1l1 1M12.1 3.9l-1 1M4.9 11.1l-1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Download = (props) => (
  <Svg {...props}>
    <path d="M8 2v8m-3-3l3 3 3-3M3 12h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Logout = (props) => (
  <Svg {...props}>
    <path d="M10.5 2H12a1.5 1.5 0 011.5 1.5v9A1.5 1.5 0 0112 14h-1.5M7 11l3-3-3-3M10 8H2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

// ── Status & Alerts ──

export const Lightning = (props) => (
  <Svg {...props}>
    <path d="M9 1.5L4 9h4l-1 5.5L12 7H8l1-5.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Warning = (props) => (
  <Svg {...props}>
    <path d="M7.13 2.5a1 1 0 011.74 0l5.5 9.5A1 1 0 0113.5 13.5h-11a1 1 0 01-.87-1.5l5.5-9.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 6v3m0 2h.005" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Clock = (props) => (
  <Svg {...props}>
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8 4.5V8l2.5 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

// ── Dashboard & Features ──

export const BarChart = (props) => (
  <Svg {...props}>
    <path d="M3 13V7m5 6V3m5 10V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </Svg>
);

export const Clipboard = (props) => (
  <Svg {...props}>
    <rect x="3" y="2" width="10" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M6 2v-.5a1.5 1.5 0 013 0V2M6 6h4m-4 2.5h4m-4 2.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Calendar = (props) => (
  <Svg {...props}>
    <rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2 6.5h12M5.5 1.5v3m5-3v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Refresh = (props) => (
  <Svg {...props}>
    <path d="M2.5 7A5.5 5.5 0 0112.9 4.5M13.5 9A5.5 5.5 0 013.1 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12.5 2v3h-3M3.5 14v-3h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Target = (props) => (
  <Svg {...props}>
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="0.75" fill="currentColor"/>
  </Svg>
);

export const TrendUp = (props) => (
  <Svg {...props}>
    <path d="M2 12l4-4 3 2 5-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 4h4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Books = (props) => (
  <Svg {...props}>
    <path d="M2 3h3a2 2 0 012 2v9a1.5 1.5 0 00-1.5-1.5H2V3zm12 0h-3a2 2 0 00-2 2v9a1.5 1.5 0 011.5-1.5H14V3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Wave = (props) => (
  <Svg {...props}>
    <path d="M8 2.5c.5-.8 1.5-1.2 2.3-.7.8.5 1 1.5.5 2.3l-.5.9M6 6l-2.5 4.3c-.5.8-.2 1.8.6 2.3.8.5 1.8.2 2.3-.6L7.5 10M10.3 5L8 9m4.5-5.5c.5-.8.2-1.8-.6-2.3-.8-.5-1.8-.2-2.3.6l-3 5.2m6.7 1.3c.5-.8.2-1.8-.6-2.3-.8-.5-1.8-.2-2.3.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

// ── Misc UI ──

export const Grid = (props) => (
  <Svg {...props}>
    <rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
  </Svg>
);

export const DragHandle = (props) => (
  <Svg {...props}>
    <circle cx="6" cy="4" r="1" fill="currentColor"/>
    <circle cx="10" cy="4" r="1" fill="currentColor"/>
    <circle cx="6" cy="8" r="1" fill="currentColor"/>
    <circle cx="10" cy="8" r="1" fill="currentColor"/>
    <circle cx="6" cy="12" r="1" fill="currentColor"/>
    <circle cx="10" cy="12" r="1" fill="currentColor"/>
  </Svg>
);

export const Trash = (props) => (
  <Svg {...props}>
    <path d="M3 4.5h10M6 4.5V3a1 1 0 011-1h2a1 1 0 011 1v1.5m2 0v8a1.5 1.5 0 01-1.5 1.5h-5A1.5 1.5 0 014 12.5v-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const ReturnArrow = (props) => (
  <Svg {...props}>
    <path d="M4 7h7a2 2 0 010 4H9M4 7l3-3M4 7l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Stable = (props) => (
  <Svg {...props}>
    <path d="M3 8h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const ExternalLink = (props) => (
  <Svg {...props}>
    <path d="M12 8.5V12a1.5 1.5 0 01-1.5 1.5h-7A1.5 1.5 0 012 12V5.5A1.5 1.5 0 013.5 4H7m3-2h4v4m-7 3L14 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const CheckCircle = (props) => (
  <Svg {...props}>
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5.5 8l2 2 3.5-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>
);

export const Upload = (props) => (
  <Svg {...props}>
    <path d="M8 10V3m-3 3l3-3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 12v1a1.5 1.5 0 001.5 1.5h7A1.5 1.5 0 0013 13v-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);

export const Gear = (props) => (
  <Svg {...props}>
    <path d="M6.86 2h2.28l.32 1.6a5 5 0 011.32.77l1.54-.52.98 1.7-1.22 1.08a5 5 0 010 1.54l1.22 1.08-.98 1.7-1.54-.52a5 5 0 01-1.32.77L9.14 12H6.86l-.32-1.6a5 5 0 01-1.32-.77l-1.54.52-.98-1.7 1.22-1.08a5 5 0 010-1.54L2.7 4.75l.98-1.7 1.54.52a5 5 0 011.32-.77L6.86 2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
    <circle cx="8" cy="7" r="2" stroke="currentColor" strokeWidth="1.3"/>
  </Svg>
);

export const Pencil = (props) => (
  <Svg {...props}>
    <path d="M10.5 2.5l3 3-8.5 8.5-3.5.5.5-3.5 8.5-8.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.5 4.5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Svg>
);
